// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"128":"4a57cda0","180":"a24ef304"}[chunkId] + ".js";
};